import { AlgoPermissions } from "../../../../../../../../../utProto/webEnums_pb";

export const ExchangePermissionMapping = {
    'NSECM': AlgoPermissions.WEBALGOPERMISSION_NSECM,
    'Nifty': AlgoPermissions.WEBALGOPERMISSION_NIFTY,
    'Midcpnifty': AlgoPermissions.WEBALGOPERMISSION_MIDCAPNIFTY,
    'NSEFO': AlgoPermissions.WEBALGOPERMISSION_NSEFO,
    'Finnifty': AlgoPermissions.WEBALGOPERMISSION_FINNIFTY,
    'Banknifty': AlgoPermissions.WEBALGOPERMISSION_BANKNIFTY,
    'BSECM': AlgoPermissions.WEBALGOPERMISSION_BSECM,
    'Sensex': AlgoPermissions.WEBALGOPERMISSION_SENSEX,
    'Bankex': AlgoPermissions.WEBALGOPERMISSION_BANKEX,
    'BSEFO': AlgoPermissions.WEBALGOPERMISSION_BSEFO,
    'All BSE Symbols': AlgoPermissions.WEBALGOPERMISSION_ALLBSESYMBOLS,
    'All NSE Symbols': AlgoPermissions.WEBALGOPERMISSION_ALLNSESYMBOLS
}

export const ExchangePermissionMappingRev = {
    [AlgoPermissions.WEBALGOPERMISSION_NSECM]: 'NSECM',
    [AlgoPermissions.WEBALGOPERMISSION_NIFTY]: 'Nifty', 
    [AlgoPermissions.WEBALGOPERMISSION_MIDCAPNIFTY]: 'Midcpnifty', 
    [AlgoPermissions.WEBALGOPERMISSION_NSEFO]: 'NSEFO',
    [AlgoPermissions.WEBALGOPERMISSION_FINNIFTY]: 'Finnifty', 
    [AlgoPermissions.WEBALGOPERMISSION_BANKNIFTY]: 'Banknifty',
    [AlgoPermissions.WEBALGOPERMISSION_BSECM]: 'BSECM', 
    [AlgoPermissions.WEBALGOPERMISSION_SENSEX]: 'Sensex', 
    [AlgoPermissions.WEBALGOPERMISSION_BANKEX]: 'Bankex', 
    [AlgoPermissions.WEBALGOPERMISSION_BSEFO]: 'BSEFO',
    [AlgoPermissions.WEBALGOPERMISSION_ALLBSESYMBOLS]: 'All BSE Symbols',
    [AlgoPermissions.WEBALGOPERMISSION_ALLNSESYMBOLS]: 'All NSE Symbols',
}
    
    
